import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    dispatchItems: [],
};

const dispatchManagementSlice = createSlice({
    name: 'dispatcher',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getDispatchSuccess(state, action) {
            state.isLoading = false;
            state.dispatchItems = action.payload;
        },
    },
});

export default dispatchManagementSlice.reducer;

export const { startLoading, hasError, getDispatchSuccess } = dispatchManagementSlice.actions;

export const getAllDispatchShipments = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('shipments/dispatched');
        dispatch(getDispatchSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};
